import InteractiveMap from './InteractiveMap';
import { LOCATION_TIMES } from '../mock';

export default function Location() {
  return (
    <section id="location" className="bg-[#e9e3d6] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <span className="eyebrow">Why Valley Mills</span>
            <h2 className="font-serif-display text-[42px] md:text-[54px] leading-[1.05] mt-6">
              Prime West Leeds,<br />
              <em className="text-[#b39352] italic">effortlessly connected.</em>
            </h2>
            <p className="mt-6 text-[14px] leading-[1.85] text-[#0d281e]/80 max-w-xl">
              Situated on Kent Road, Pudsey — an ideal base serving Leeds, Bradford and the wider
              Yorkshire region with immediate access to the motorway network.
            </p>

            <div className="mt-10 grid grid-cols-2 gap-x-8 gap-y-4 max-w-md">
              {LOCATION_TIMES.map((t) => (
                <div key={t.place} className="border-t border-[#0d281e]/15 pt-4">
                  <div className="font-serif-display text-[36px] text-[#0d281e] leading-none">{t.time}</div>
                  <div className="text-[11px] tracking-[0.18em] text-[#0d281e]/70 mt-2 uppercase">{t.place}</div>
                </div>
              ))}
            </div>

            <div className="mt-10 flex items-center gap-4">
              <span className="text-[10px] tracking-[0.28em] text-[#b39352]">NEARBY</span>
              <span className="text-[13px] text-[#0d281e]">New Pudsey Station</span>
            </div>
          </div>

          <div className="relative">
            <InteractiveMap />
          </div>
        </div>
      </div>
    </section>
  );
}
